var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPaylink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 15,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5H19C19.2761 5.5 19.5 5.72386 19.5 6V10C19.5 10.2761 19.2761 10.5 19 10.5H4C3.72386 10.5 3.5 10.2761 3.5 10V6C3.5 5.72386 3.72386 5.5 4 5.5Z",
    stroke: "#243BE2",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.25H8.25",
    stroke: "#243BE2",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.75C10.5 7.33579 10.8358 7 11.25 7H15.25C15.6642 7 16 7.33579 16 7.75V8.75C16 9.16421 15.6642 9.5 15.25 9.5H11.25C10.8358 9.5 10.5 9.16421 10.5 8.75V7.75Z",
    fill: "#243BE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPaylink);
export default __webpack_public_path__ + "static/media/card-paylink.e2e81766b6440385413c4730555d6185.svg";
export { ForwardRef as ReactComponent };